module.exports = __webpack_public_path__ + "assets/img/thumb-DB-Results-Service-Page.b9c05867.webp";